<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="end">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">NLP-AI任务列表</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <a-button type="primary" @click="editInfo('add')">
                            添加任务
                        </a-button>

                        <a-button type="danger" @click="startEcs()" style="margin-left: 20px;">
                            立即启动
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '10px 24px 10px 24px'}">
                <a-row>
                    <a-col :span="6" :offset="12" style="padding-left: 10px;">
                        <a-select
                            mode="multiple"
                            :default-value="[]"
                            style="width: 100%"
                            placeholder="请选择网站"
                            @change="handleSelectWebsiteChange"
                        >
                            <a-select-option v-for="i in website" :key="i.uuid">
                                {{ i.title }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="6" style="padding-left: 10px;">
                        <a-select
                            mode="multiple"
                            :default-value="[]"
                            style="width: 100%"
                            placeholder="请选择文章标签"
                            @change="handleSelectCategoryChange"
                        >
                            <a-select-option v-for="i in category" :key="i.uuid">
                                {{ i.title }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '2px 24px 24px 24px'}">
                <a-table
                    :columns="columns"
                    :row-key="record => record.articleBotTaskDO.uuid"
                    :data-source="data"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >
                    <!--                    <span slot="display" slot-scope="display">-->
                    <!--                        <a-tag-->
                    <!--                            v-for="tag in display"-->
                    <!--                            :key="tag"-->
                    <!--                            :color="tag === '是' ? 'green' : '#f50'"-->
                    <!--                        >-->
                    <!--                            {{ tag }}-->
                    <!--                        </a-tag>-->
                    <!--                    </span>-->


                    <span slot="work" slot-scope="work,row">
                        <a-switch checked-children="启用" un-checked-children="不启用" :default-checked="work === true"
                                  @change="switchChangeForWork($event,row.articleBotTaskDO.uuid)"/>
                    </span>

                    <span slot="action" slot-scope="record">

                        <a href="javascript:;" @click="editInfo(record.articleBotTaskDO.uuid)"
                           style="margin-left: 5px;">编辑</a>

                        <a-popconfirm
                            v-if="data.length"
                            title="确定删除该任务吗?"
                            @confirm="() => deleteProduct(record.articleBotTaskDO.uuid)"
                            ok-text="删除"
                            cancel-text="取消"
                            style="margin-left: 5px;"
                        >
                            <a href="javascript:;">删除</a>
                        </a-popconfirm>
                    </span>


                    <!--                    <a-row slot="expandedRowRender" slot-scope="record" style="margin: 0">-->
                    <!--                        <a-col :span="6">-->
                    <!--                            <span class="tb-content-title">关键词：</span>{{ record.articleBotTaskDO.keyword }}-->
                    <!--                        </a-col>-->
                    <!--                        <a-col :span="18">-->
                    <!--                            <span class="tb-content-title">快捷连接：</span>{{-->
                    <!--                                '/article/' + record.articleBotTaskDO.uuid + '.html'-->
                    <!--                            }}-->
                    <!--                        </a-col>-->
                    <!--                    </a-row>-->
                </a-table>
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {
    name: "ArticleBot",
    data() {
        const columns = [
            {
                title: '任务关键词',
                dataIndex: 'articleBotTaskDO.keyword',
                sorter: false,
            },
            {
                title: '标签',
                dataIndex: 'articleTagDO.title',
                sorter: false,
            },
            {
                title: '所属网站',
                dataIndex: 'websiteDO.title',
                sorter: false,
            },
            {
                title: '每日数量',
                dataIndex: 'articleBotTaskDO.perDayNum',
                sorter: false,
                align: 'center'
            },
            {
                title: '段落数',
                dataIndex: 'articleBotTaskDO.spNum',
                sorter: false,
                align: 'center'
            },
            {
                title: '是否启用',
                dataIndex: 'articleBotTaskDO.work',
                sorter: false,
                scopedSlots: {customRender: 'work'},
                width: '120px',
                align: 'center'
            },
            {
                title: '截止时间',
                dataIndex: 'articleBotTaskDO.endDate',
                sorter: true,
            },
            {
                title: '创建时间',
                dataIndex: 'articleBotTaskDO.createTime',
                sorter: true,
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'x',
                scopedSlots: {
                    customRender: 'action'
                },
                width: '10%'
            },
        ];
        return {
            data: [],
            pagination: {},
            loading: false,
            columns,
            website: [],
            category: [],
            paramWebsite: [],
            paramCategory: []
        };
    },
    methods: {
        switchChangeForWork(checked, uuid) {
            this.update({
                'uuid': uuid,
                'work': checked
            });
        },
        startEcs() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/articleBot/run", {}).then(function (res) {
                const result = res.data;
                that.$message.warn(result.msg);
            }).catch(function (err) {
                console.log(err)
            });
        },
        update(p) {
            let that = this;
            this.$ajax.post(this.$host + "/admin/articleBotTask/update", p).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.fetch();
                } else {
                    that.$message.warn(result.msg);
                }
            }).catch(function (err) {
                console.log(err)
            });
        },

        editInfo(uuid) {
            this.$router.push({
                name: "articleBotAdd",
                params: {
                    articleBotTask: uuid
                }
            });
        },
        handleTableChange(pagination, filters, sorter) {
            const pager = {...this.pagination};
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                size: pagination.pageSize,
                page: pagination.current,
                website: this.paramWebsite,
                category: this.paramCategory,
                sortField: sorter.field,
                sortOrder: sorter.order,
            });
        },
        fetch: function (params = {}) {
            this.loading = true
            let that = this
            this.$ajax.post(this.$host + "/admin/articleBotTask/list", params).then(function (res) {
                that.loading = false
                const result = res.data;
                if (result.code === 200) {
                    const pagination = {...that.pagination};
                    pagination.total = result.data.total;
                    that.data = result.data.list;
                    that.pagination = pagination;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        getWebsite() {
            let that = this;
            this.$ajax.get(this.$host + "/admin/website/listAll", {
                params: {}
            }).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.website = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        getProCategory(websiteList) {
            let that = this;
            this.$ajax.post(this.$host + "/admin/articleTag/listByWebsiteList", websiteList).then(function (res) {
                const result = res.data;
                if (result.code === 200) {
                    that.category = result.data;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        handleSelectWebsiteChange(value) {
            this.paramWebsite = value;
            this.getProCategory(value);
            this.fetch({
                website: this.paramWebsite,
                category: this.paramCategory
            });
        },
        handleSelectCategoryChange(value) {
            this.paramCategory = value;
            this.fetch({
                website: this.paramWebsite,
                category: this.paramCategory
            });
        },
        deleteProduct: function (articleBotTask) {
            let params = new FormData();
            params.set("articleBotTask", articleBotTask);
            let that = this;
            this.$ajax.post(this.$host + "/admin/articleBotTask/delete", params)
                .then(function (res) {
                    const result = res.data;
                    that.$message.info(result.msg);
                    if (result.code === 200) {
                        that.fetch();
                    }
                }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.fetch();
        this.getWebsite();
    }
}
</script>

<style scoped>

</style>